import useClassy from '@core/hooks/useClassy';
import AgentRiveAnimation from '@routes/SuperHub/AI/Chat/ChatEditor/components/AgentRiveAnimation';
import SheenBox from '@ui/SheenBox';
import TypewriterCycle from '@ui/TypewriterCycle';

import classes from './style.module.scss';

const XImportBlock = ({ style }: { style?: React.CSSProperties }) => {
  const bem = useClassy(classes, 'XImportBlock');
  return (
    <SheenBox
      sheen={['light-dark(var(--blue60), var(--blue20))']}
      duration="15s"
      bezier="ease-in-out"
      opacity={0.7}
      width={1}
      className={bem()}
      style={style}
    >
      <h3 className={bem('-header')}>
        <span className={bem('-icon')}>
          <AgentRiveAnimation className={bem('-icon-graphic')} isLoading={true} size={30} />
        </span>
        <TypewriterCycle
          random
          copy={[
            'We’re working on it',
            'Coalescing import vertices',
            'Summoning all the bytes',
            'Pulling at digital threads',
            'Whittling down the queue',
            'Coaxing meta caches',
            'Massaging the larger context',
            'Reverse-engineering the vibes',
            'Tuning the import harmonics',
            'Shepherding stray packets',
            'Flossing the bit stream',
            'Conceptualizing doc metas',
            'Spinning our collective heads',
            'Consulting the spirits of tokens passed',
            'Reticulating splines',
          ]}
          suffix="…"
          timing={60}
          delay={2750}
        />
      </h3>

      <p>
        Hold tight while we generate a complete docs site for you. We’ll email you when everything’s done, but we’re
        pushing updates as we go so check back periodically for page-by-page progress!
      </p>

      <hr />

      <p>
        Questions about ReadMe? Issues with the import?&nbsp;
        <a href="mailto:support@readme.io?subject=ReadMe%27s%20AI%20Import%20process" target="_blank">
          Chat with our support team
        </a>
        .
      </p>
    </SheenBox>
  );
};

export default XImportBlock;
